class Nav {
	constructor() {
		this.header = document.querySelector(".header-main");

		if (!this.header) {
			return;
		}

		if (!this.header.classList.contains("header-main-no-change")) {
			this.toggleHeaderOnScroll();
		}
		this.toggleMobileNavOnClick();
		resizeCallbacks.push(this);
	}

	toggleMobileNavOnClick() {
		const openTrigger = document.querySelector(".nav-main-open");
		const closeTrigger = document.querySelector(".nav-main-close");

		if (openTrigger) {
			openTrigger.addEventListener("click", () => {
				this.openNav();
			});
		}

		if (closeTrigger) {
			closeTrigger.addEventListener("click", () => {
				this.closeNav();
			});
		}
	}

	toggleHeaderOnScroll() {
		ScrollTrigger.create({
			trigger: document.querySelector(".banner"),
			start: "5% top",
			endTrigger: document.querySelector(".footer-main"),
			end: "bottom bottom+10",
			onToggle: () => {
				this.header.classList.toggle("at-top");
			}
		});
	}

	openNav() {
		document.body.classList.add("nav-is-opened");
		smoother.paused(true);
	}

	closeNav() {
		document.body.classList.remove("nav-is-opened");
		smoother.paused(false);
	}

	resize() {
		this.closeNav();
	}
}